export default "__VITE_ASSET__DAXb31ej__"